import { FC, MouseEvent } from 'react';
import AppBarButton, { AppBarButtonProps } from './AppBarButton';
import MenuIcon from '@mui/icons-material/Menu';

export interface AppBarHamburgerProps extends AppBarButtonProps {
  onClick: (e: MouseEvent) => void;
}

const AppBarHamburger: FC<AppBarHamburgerProps> = (props) => {
  return <AppBarButton startIcon={<MenuIcon />} {...props} />;
};

export default AppBarHamburger;
